import { render, staticRenderFns } from "./editPriceList.vue?vue&type=template&id=2b386785&scoped=true"
import script from "./editPriceList.vue?vue&type=script&lang=js"
export * from "./editPriceList.vue?vue&type=script&lang=js"
import style0 from "./editPriceList.vue?vue&type=style&index=0&id=2b386785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b386785",
  null
  
)

export default component.exports